import React from 'react';
import { isNil } from 'ramda';
import FormattedCurrency from 'components/ui/FormattedCurrency';
import PropTypes from 'prop-types';
import LoyaltyPointsInfos from '../LoyaltyPointsInfos';

export const PricesAndPointsSummary = ({ price, currency, isLoyalty = false, points }) =>
  !isNil(price) ? (
    <>
      <FormattedCurrency amount={price} currency={currency} />
      {isLoyalty && <LoyaltyPointsInfos dataId="points-details" id="searchResults.pts" values={points} />}
    </>
  ) : (
    <>{isLoyalty && <LoyaltyPointsInfos dataId="points-details" id="searchResults.pts" values={points} />}</>
  );

PricesAndPointsSummary.propTypes = {
  price: PropTypes.number,
  currency: PropTypes.string,
  isLoyalty: PropTypes.bool,
  points: PropTypes.number
};
